import { TranslocoPipe } from '@jsverse/transloco';
import { Component, Input } from '@angular/core';
import { AccountFilterData, DateIntervalFilterData, SummaryRequest } from '../../../../../_shared/models';
import { BaseWidgetComponent } from '../../../../../home/home-widgets/widgets/base-widget.component';
import { FuelConsumptionService } from '../../../services/fuel-consumption.service';
import { FilterService } from '../../../../../_shared/services';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ErrorHandlerService } from '../../../../../_shared/services/error-handler.service';
import { transformValue } from '../../../../../_shared/helpers/kpiWidget/kpi-formatters.helper';
import { KpiWidgetComponent } from '../../../../../_shared/components/kpi-widget/kpi-widget.component';

@Component({
  selector: 'app-total-fuel-used-widget',
  standalone: true,
  imports: [TranslocoPipe, KpiWidgetComponent],
  templateUrl: './total-fuel-used-widget.component.html',
  styleUrl: './total-fuel-used-widget.component.scss'
})
export class TotalFuelUsedWidgetComponent extends BaseWidgetComponent {
  @Input() dateFilter: DateIntervalFilterData;
  @Input() accountFilter: AccountFilterData;
  @Input() modalFilterHeaders: { previous: string; current: string };
  fuelUsedPercentageChange: any;
  request: SummaryRequest;
  icon: string = 'assets/images-fuel/fulePampIcon.svg';
  hasError: boolean = false;
  errorMessage: string = '';

  constructor(
    private fuelConsumptionService: FuelConsumptionService,
    protected override filterService: FilterService,
    private modalService: NgbModal,
    private errorHandlerService: ErrorHandlerService
  ) {
    super(filterService);
    this.title = 'Total Fuel Used';
    this.isLoading = false;
    this.value = 0;
    this.difference = 0;
    this.widgetDisabled = true;
  }

  protected override async onFilterChangeAsync(): Promise<void> {
    await this.getTotalFuelUsed();
  }

  public override formatValue(value: number): string {
    return `${transformValue(value)} ℓ`;
  }

  async getTotalFuelUsed() {
    this.isLoading = true;
    this.hasError = false;

    try {
      this.request = {
        accountIds: this.widgetFilter.accountIds,
        timeFrom: this.widgetFilter.startDate!,
        timeTo: this.widgetFilter.endDate!,
        previousTimeFrom: this.widgetFilter.previousCycleStartDate!,
        previousTimeTo: this.widgetFilter.previousCycleEndDate!
      }

      this.cancelSubject.next();
      const response = await this.fuelConsumptionService.getTotalFuelUsedKpiStats(this.request, this.cancelSubject);
      this.value = response.data?.totalValue ?? 0;
      this.fuelUsedPercentageChange = response.data?.percentageChange;
      this.isLoading = false;
    } catch (error: any) {
      this.errorHandlerService.handleError(error, {
        callback: (message) => {
          this.errorMessage = message;
          this.hasError = true;
          this.isLoading = false;
        }
      });
    }
  }
}